module.exports = __webpack_public_path__ + "static/fonts/Montserrat700.a3b387c9.ttf";